import type { CarrierLogoProps } from './types'
import LogoSvg from '../../assets/carrier-logos/veho-logo.svg?react'
import { chakra } from '../../chakra'
import { getLogoProps } from './use-logo-props'
import * as React from 'react'

const Logo = chakra(LogoSvg)

export const VEHOLogo = React.forwardRef<SVGSVGElement, CarrierLogoProps>(
  function VEHOLogo(props, ref) {
    const logoProps = getLogoProps(props)

    return <Logo {...logoProps} ref={ref} />
  },
)
